import React from 'react'
import "./Booking.css"
import {Link} from "react-router-dom"
import Navbar from "../Navbar/Navbar"

const Booking = () => {
  return (
    <div className='portal-kiga-booking-main'>
     <Navbar/>
     <section className='portal-kiga-booking-section'  style={{
  background: `linear-gradient(
    to top,
    rgba(0, 0, 0, 0.52),
    rgba(0, 0, 0, 0.73)
  ), url('/images/Gallery/bac1.jpg')`,
  backgroundAttachment: 'fixed',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundPosition: 'center'
}}>
      <div className='kiga-portal-section-constant-header'>
       <p>Let's see what's available!</p>
       <p>What would you like to view?</p>
       </div>
       <div className='kiga-portal-section-box-flex'>

         <div className='kiga-portal-section-box'>
          <div className='kiga-portal-section-box-title'>
           <Link to='/portal/booking/wizard-question-1'>
             Find a Class
           </Link>
          </div>
          <div className='kiga-portal-section-box-image'>
            <img src='/images/Gallery/child1.jpg' alt='class'/>
          </div>
         </div>

         <div className='kiga-portal-section-box'>
          <div className='kiga-portal-section-box-title'>
            <Link to="/portal/booking/party/party-booking-01-date">Book a Party</Link>
          </div>     
          <div className='kiga-portal-section-box-image'>
            <img src='/images/Gallery/child2.jpg' alt='class'/>
          </div>
         </div>

         <div className='kiga-portal-section-box'>
          <div className='kiga-portal-section-box-title'>
            <Link to={null}>Holiday Activities</Link>
          </div>
          <div className='kiga-portal-section-box-image'>
            <img src='/images/Gallery/holiday.jpg' alt='class'/>
          </div>
         </div>

       </div>
     </section>
    </div>
  )
}

export default Booking